<script>
import Auth from "@/pages/layouts/auth.vue";
import Input from "@/pages/components/form/vertical/input.vue";
import {useForm, router} from "@inertiajs/vue3";

export default {
  components: {
    Auth,
    Input
  },
  data() {
    return {
      form: useForm({
        'one_time_password': ''
      })
    }
  },
  methods: {
    submit() {
      $.ajax({
        url: route('2fa'),
        method: 'POST',
        data: this.form.data(),
        success: (response) => {
          router.reload();
        },
        error: (response) => {
          this.form.errors['one_time_password'] = response.responseJSON.message;
        }
      })
    }
  }
}
</script>

<template>
  <Auth title="2 staps authenticatie">
    <form class="form-horizontal form-material" @submit.prevent="submit">
      <Input
          v-model="form.one_time_password"
          :form="form"
          name="one_time_password"
          placeholder="Voer de code van de 2-factor app in"
          required
          autofocus
          autocomplete="current-password"
      />

      <div class="form-group">
        <button :disabled="form.processing" class="btn w-100 btn-lg btn-primary btn-rounded text-white" type="submit">Verifieer code</button>
      </div>
    </form>
  </Auth>
</template>